module.exports = __webpack_public_path__ + "static/media/flower.585a5b4e.svg";